export default __webpack_public_path__ + "static/media/Legend2.80873809.jpeg";